import React from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';
import className from 'classnames';
import ImageLoader from './ImageLoader'

const PostsListItemVideo = ({
  video,
}) => {
  const [isActive, isActiveSet] = React.useState(false)
  const $video = React.useRef()

  React.useEffect(() => {
    if (isActive && $video.current) {
      $video.current.play()
    }
  }, [isActive])

  return (
    <div
      className='Posts__item__right__middle__videos__item'
      style={{
        width: get(video, 'width'),
        height: get(video, 'height'),
      }}
    >
      {get(video, 'videoUrl') &&
        <div
          className='Posts__item__right__middle__videos__item__img'
          style={{
            maxWidth: get(video, 'width'),
            height: get(video, 'height'),
          }}
        >
          {isActive ?
            <video
              controls
              autoPlay
              ref={$video}
            >
              <source
                src={get(video, 'videoUrl')}
              />
            </video>
          :
            <a
              className='Posts__item__right__middle__videos__item__img__a Video'
              onClick={() => {
                isActiveSet(true)
              }}
            >
              <ImageLoader
                url={get(video, 'thumbnailUrl')}
                wrapped={false}
              />
            </a>
          }
        </div>
      }
    </div>
  )
}

PostsListItemVideo.propTypes = {
};

export default PostsListItemVideo;
